import { render } from "./ErrorMessages.vue?vue&type=template&id=181f0d7e&scoped=true"
import script from "./ErrorMessages.vue?vue&type=script&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&lang=js"

import "./ErrorMessages.vue?vue&type=style&index=0&id=181f0d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181f0d7e"]])

export default __exports__